import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { TestId } from '../../enums/test';
import { Message } from '../Message/index.types';
import Timestamp from './Timestamp';

type Props = PropsWithChildren & {
    className?: string;
    timestamp?: Message['createdAt'];
};

function UserBubble({ className, timestamp, children }: Props) {
    if (!children) return null;

    return (
        <div
            className={clsx(
                'flex flex-col gap-5 p-15 w-fit max-w-full bg-[#D9EBFF] rounded-20 rounded-br-5',
                className,
            )}
            data-testid={TestId.USER_BUBBLE}
        >
            {timestamp && <Timestamp timestamp={timestamp} className='text-right' />}
            {children}
        </div>
    );
}

export default UserBubble;
